import { MutationObserver, MutationObserverOptions } from '@tanstack/query-core';
import { queryClient } from '../core/queryClient';

export function createMutation<TInput, TResult>(
  options: MutationObserverOptions<TResult, Error, TInput>
): MutationObserver<TResult, Error, TInput> {
  return new MutationObserver<TResult, Error, TInput>(queryClient, options);
}
